module.exports = __webpack_public_path__ + "static/media/14.98a9401b.png";